import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorhandlerService {
  constructor() {}

  handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';

    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Server-side error
      switch (error.status) {
        case 400:
          errorMessage = 'Bad Request. Please check the request parameters.';
          break;
        case 401:
          errorMessage = 'Unauthorized. Please log in again.';
          break;
        case 403:
          errorMessage = 'Forbidden. You do not have permission to access this resource.';
          break;
        case 404:
          errorMessage = 'Not Found. The requested resource was not found.';
          break;
        case 413:
          errorMessage = 'Request Entity Too Large';
          break;
        case 500:
          errorMessage = 'Internal Server Error. Something went wrong on the server.';
          break;
        case 503:
          errorMessage = 'Service Unavailable. Please try again later.';
          break;
        default:
          errorMessage = `Unexpected error: ${error.status}`;
      }
    }
    // Return an observable with a user-friendly error message
    return throwError(errorMessage);
  }

  getErrorDetails(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      // Client-side error
      errorMessage = `Client-side error: ${error.error.message}`;
    } else {
      // Server-side error
      switch (error.status) {
        case 400:
          errorMessage = 'Bad Request. Please check the request parameters.';
          break;
        case 401:
          errorMessage = 'Unauthorized. Please log in again.';
          break;
        case 403:
          errorMessage = 'Forbidden. You do not have permission to access this resource.';
          break;
        case 404:
          errorMessage = 'Not Found. The requested resource was not found.';
          break;
        case 413:
          errorMessage = 'Request Entity Too Large';
          break;
        case 500:
          errorMessage = 'Internal Server Error. Something went wrong on the server.';
          break;
        case 503:
          errorMessage = 'Service Unavailable. Please try again later.';
          break;
        default:
          errorMessage = `Unexpected error: ${error.status}`;
      }
    }
    const errors = { errorMessage: errorMessage, error: error.error };
    return throwError(errors); // Return an observable with a user-friendly error message
  }
}
